import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./media.css";
import { v4 as uuidv4 } from "uuid"; // Import uuid
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";

// bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "../node_modules/bootstrap/dist/js/bootstrap";


import { BrowserRouter } from "react-router-dom";
const sessionIdTemp = localStorage.getItem("session_id");
if (sessionIdTemp == null) {
  const sessionId = uuidv4(); // Generate a unique session ID
  localStorage.setItem("session_id", sessionId);
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
